;(function () {
  function create_liquid_glass_element(text_value, icon_elements, link_attributes) {
    // Use anchor tag if href exists, otherwise use div
    var wrapper_el = link_attributes && link_attributes.href 
      ? document.createElement('a')
      : document.createElement('div')
    wrapper_el.className = 'wrapper'

    // Apply link attributes if they exist
    if (link_attributes) {
      if (link_attributes.href) {
        wrapper_el.href = link_attributes.href
      }
      if (link_attributes.target) {
        wrapper_el.target = link_attributes.target
      }
      if (link_attributes.rel) {
        wrapper_el.rel = link_attributes.rel
      }
      if (link_attributes.title) {
        wrapper_el.title = link_attributes.title
      }
      // Copy any other attributes
      if (link_attributes.other_attrs) {
        for (var attr_name in link_attributes.other_attrs) {
          if (link_attributes.other_attrs.hasOwnProperty(attr_name)) {
            wrapper_el.setAttribute(attr_name, link_attributes.other_attrs[attr_name])
          }
        }
      }
    }

    var glass_wrapper_el = document.createElement('div')
    glass_wrapper_el.className = '_custom-liquid-glass-wrapper dock'

    var effect_el = document.createElement('div')
    effect_el.className = '_custom-liquid-glass-effect'

    var tint_el = document.createElement('div')
    tint_el.className = '_custom-liquid-glass-tint'

    var shine_el = document.createElement('div')
    shine_el.className = '_custom-liquid-glass-shine'

    glass_wrapper_el.appendChild(effect_el)
    glass_wrapper_el.appendChild(tint_el)
    glass_wrapper_el.appendChild(shine_el)

    // Add icon elements if they exist (after effect layers, before text)
    if (icon_elements && icon_elements.length > 0) {
      for (var i = 0; i < icon_elements.length; i++) {
        var cloned_icon = icon_elements[i].cloneNode(true)
        // Ensure icons are visible above the glass effect layers
        cloned_icon.style.position = 'relative'
        cloned_icon.style.zIndex = '3'
        glass_wrapper_el.appendChild(cloned_icon)
      }
    }

    var text_el = document.createElement('div')
    text_el.className = '_custom-liquid-glass-text'
    text_el.textContent = text_value || ''
    glass_wrapper_el.appendChild(text_el)
    wrapper_el.appendChild(glass_wrapper_el)
    return wrapper_el
  }

  function apply_liquid_glass_to_element(target_el) {
    var text_value = ''
    try {
      text_value = (target_el.textContent || '').trim()
    } catch (e) {
      text_value = ''
    }
    if (!text_value) {
      text_value = 'Velkommen'
    }

    // Find and preserve icon elements (prioritize icon containers, then img/svg)
    var icon_elements = []
    try {
      // First, look for elements with icon-related classes (x-icon, icon, etc.)
      // These are usually containers that wrap the actual icon
      var icon_class_elements = target_el.querySelectorAll('[class*="icon"], [class*="Icon"]')
      if (icon_class_elements && icon_class_elements.length > 0) {
        Array.prototype.forEach.call(icon_class_elements, function(icon_el) {
          // Check if this element contains an img or svg (it's likely an icon container)
          var has_icon_content = icon_el.querySelector('img, svg') !== null || 
                                 icon_el.tagName === 'IMG' || 
                                 icon_el.tagName === 'SVG'
          if (has_icon_content) {
            icon_elements.push(icon_el)
          }
        })
      }

      // If no icon containers found, look for img/svg elements directly
      if (icon_elements.length === 0) {
        var img_elements = target_el.querySelectorAll('img')
        if (img_elements && img_elements.length > 0) {
          Array.prototype.forEach.call(img_elements, function(img) {
            icon_elements.push(img)
          })
        }

        var svg_elements = target_el.querySelectorAll('svg')
        if (svg_elements && svg_elements.length > 0) {
          Array.prototype.forEach.call(svg_elements, function(svg) {
            icon_elements.push(svg)
          })
        }
      }
    } catch (e) {
      // If icon detection fails, continue without icons
    }

    // Extract link attributes (href, target, rel, etc.)
    var link_attributes = {}
    try {
      if (target_el.href) {
        link_attributes.href = target_el.href
      }
      if (target_el.target) {
        link_attributes.target = target_el.target
      }
      if (target_el.rel) {
        link_attributes.rel = target_el.rel
      }
      if (target_el.title) {
        link_attributes.title = target_el.title
      }
      // Copy other attributes that might be useful
      if (target_el.attributes && target_el.attributes.length > 0) {
        link_attributes.other_attrs = {}
        for (var i = 0; i < target_el.attributes.length; i++) {
          var attr = target_el.attributes[i]
          var attr_name = attr.name.toLowerCase()
          // Skip class and id as they're handled separately, and already captured attributes
          if (attr_name !== 'class' && 
              attr_name !== 'id' && 
              attr_name !== 'href' && 
              attr_name !== 'target' && 
              attr_name !== 'rel' && 
              attr_name !== 'title') {
            link_attributes.other_attrs[attr.name] = attr.value
          }
        }
      }
    } catch (e) {
      // If attribute extraction fails, continue without link attributes
    }

    var replacement = create_liquid_glass_element(text_value, icon_elements, link_attributes)
    var parent = target_el.parentNode
    if (parent && parent.replaceChild) {
      parent.replaceChild(replacement, target_el)
    } else {
      // Fallback: mutate in place if parent is unavailable
      while (target_el.firstChild) target_el.removeChild(target_el.firstChild)
      target_el.appendChild(replacement)
    }
  }

  function init_custom_liquid_glass_buttons() {
    var targets = document.querySelectorAll('._custom-liquid-glass-button')
    if (!targets || !targets.length) return
    Array.prototype.forEach.call(targets, apply_liquid_glass_to_element)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init_custom_liquid_glass_buttons()
    })
  } else {
    init_custom_liquid_glass_buttons()
  }

  document.addEventListener('shopify:section:load', function () {
    init_custom_liquid_glass_buttons()
  })
  document.addEventListener('shopify:section:select', function () {
    init_custom_liquid_glass_buttons()
  })
})()

